import $ from 'cash-dom';
import { get, set } from 'lodash';
import React from 'react';
import ReactDOM from 'react-dom';

import NavJumpLink from 'components/NavJumpLink';

const _cache = {};

const JumpToContentController = class {
  static get $skipToContent() {
    if (!get(_cache, '$skipToContent')) {
      set(_cache, '$skipToContent', $('#skip-to-content-container'));
    }

    return get(_cache, '$skipToContent');
  }

  static get skipToContentTarget() {
    return JumpToContentController.$skipToContent.data('href');
  }

  static get skipToContentElement() {
    return JumpToContentController.$skipToContent.get(0);
  }

  static mountJumpLink = () => {
    ReactDOM.render(
      <NavJumpLink href={JumpToContentController.skipToContentTarget} />,
      JumpToContentController.skipToContentElement
    );
  };

  static init = () => {
    JumpToContentController.mountJumpLink();
  };
};

export default JumpToContentController;
